/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_BlockInputs */

const en_profile_block = /** @type {(inputs: Profile_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Block User`)
};

const es_profile_block = /** @type {(inputs: Profile_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloquear Usuario`)
};

const fr_profile_block = /** @type {(inputs: Profile_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloquer l'utilisateur`)
};

const de_profile_block = /** @type {(inputs: Profile_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzer blockieren`)
};

const id_profile_block = /** @type {(inputs: Profile_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blokir Pengguna`)
};

/** @type {(inputs: Profile_BlockInputs) => LocalizedString} */
const ja_profile_block = en_profile_block;

/** @type {(inputs: Profile_BlockInputs) => LocalizedString} */
const zh_profile_block = en_profile_block;

/** @type {(inputs: Profile_BlockInputs) => LocalizedString} */
const ar_profile_block = en_profile_block;

/** @type {(inputs: Profile_BlockInputs) => LocalizedString} */
const it_profile_block = en_profile_block;

/** @type {(inputs: Profile_BlockInputs) => LocalizedString} */
const ru_profile_block = en_profile_block;

/** @type {(inputs: Profile_BlockInputs) => LocalizedString} */
const pt_profile_block = en_profile_block;

/** @type {(inputs: Profile_BlockInputs) => LocalizedString} */
const ko_profile_block = en_profile_block;

/**
* | output |
* | --- |
* | "Block User" |
*
* @param {Profile_BlockInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const profile_block = /** @type {((inputs?: Profile_BlockInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_BlockInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_block(inputs)
	if (locale === "es") return es_profile_block(inputs)
	if (locale === "fr") return fr_profile_block(inputs)
	if (locale === "de") return de_profile_block(inputs)
	if (locale === "ja") return ja_profile_block(inputs)
	if (locale === "zh") return zh_profile_block(inputs)
	if (locale === "ar") return ar_profile_block(inputs)
	if (locale === "id") return id_profile_block(inputs)
	if (locale === "it") return it_profile_block(inputs)
	if (locale === "ru") return ru_profile_block(inputs)
	if (locale === "pt") return pt_profile_block(inputs)
	return ko_profile_block(inputs)
});